import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AdvVoicemailboxWithExt } from "../../admin-voicemail-types";

@Component({
  selector: "onsip-admin-voicemail-greeting-tab",
  templateUrl: "./admin-voicemail-greeting-tab.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AdminVoicemailGreetingTabComponent {
  @Input() voicemail!: AdvVoicemailboxWithExt;
  @Output() mode = new EventEmitter<"view" | "edit">();

  voicemailShelfPanel = new BehaviorSubject<"view" | "edit">("view");

  togglePanel(panel: "view" | "edit"): void {
    this.voicemailShelfPanel.next(panel);
    this.mode.emit(panel);
  }
}
